module.exports = __webpack_public_path__ + "static/AAppoint_Logo-8c69797715cb1a7ab9da4bf5ddf8c007.svg";